module.exports = __webpack_public_path__ + "894aef12de497a37a493a6354feb79cf.png";